import classes from "./chip.module.scss";
import { useState } from "react";
import { ChipProps } from "./interface";
import ChipIcon from "./chipIcon";
import { IconNames } from "../../Foundation/Icons";
import classNames from "classnames/bind";
import { IconColours } from "../../Foundation/Icons/interface";

const Chip = ({ label, onClick, active = false, disabled }: ChipProps) => {
    const [isActive, setIsActive] = useState<boolean>(active);

    const cx = classNames.bind(classes);
    const chipClasses = cx(
        "chip",
        { active: active },
        { disabled: disabled },
        { enabled: !disabled }
    );

    const handleOnClick = (e: React.SyntheticEvent<EventTarget>) => {
        setIsActive(!isActive);
        if (onClick) {
            onClick();
        }
    };

    return (
        <button
            onClick={handleOnClick}
            className={chipClasses}
            disabled={disabled}
            aria-pressed={isActive}
        >
            <ChipIcon
                isActive={isActive}
                iconName={IconNames.Check}
                iconType="outlined"
                colour={IconColours.white}
                secondaryColour={IconColours.black}
            />
            <span className={classes.chipText}>{label}</span>
            <ChipIcon
                isActive={isActive}
                iconName={IconNames.Close}
                iconType="filled"
                colour={IconColours.black}
                secondaryColour={IconColours.black}
                size="28"
            />
        </button>
    );
};

export default Chip;
